// Sender-Fields composer read keys. Co-located *Keys factory so the query-key
// array literals live outside the component (stale-after-save gate rule). These
// are short-lived composer reads (deal / final-financial-addendum / covenant
// calibration) used only to prefill sender fields — no mutation invalidates
// them, so they need no matching invalidation surface.

export const senderDetailsKeys = {
  deal: (dealId: string | null) => ["deal-for-sender", dealId] as const,
  addendum: (dealId: string | null) => ["addendum-for-sender", dealId] as const,
  calibration: (loanId: string | null) =>
    ["calibration-for-sender", loanId] as const,
};
